var UNDEFINED = "undefined";

export default function defined(value) {
    return typeof value !== UNDEFINED;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/util/defined.js
// module id = 94
// module chunks = 0